<!-- <form [formGroup]="utilizationForm"></form> -->
<form [formGroup]="utilizationForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.utilizationOptionForm.choose_person' | translate}}</mat-label>
        <mat-select formControlName="option">
            <mat-option *ngFor="let opt of utilizationOptions" [value]="opt">{{opt.title}} {{opt.personName}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div [hidden]="!showPersonSelect">
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.utilizationOptionForm.choose_person' | translate}}</mat-label>
            <mat-select formControlName="person">
                <mat-option *ngFor="let person of data.person" [value]="person">{{person.anzeigeName}}</mat-option>
            </mat-select>
            <mat-error *ngIf="utilizationForm.errors?.personRequired">{{'FORM_VALIDATION.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
    </div>
    <button [disabled]="utilizationForm.invalid" class="spanw w-100" mat-raised-button color="primary"
            type="submit">
            {{ 'FORM.BTN_SET' | translate }}
    </button>
</form>
